import { computed, nextTick, watch } from 'vue'
import { type RegionCode } from '../all-countries'
import GatPhoneEditFunctions from '../functions/GatPhoneEditFunctions'
import { type GatPhoneEditProps } from '../gat-phone-edit.vue'
import type { CountryAndDialCode } from '../types/CountryAndDialCode'

export function useCountryCode(
  props: GatPhoneEditProps,
  setSelectedCountry?: (country: CountryAndDialCode | undefined) => void
) {
  const userCountryCode = computed(
    (): RegionCode | (string & {}) | undefined => undefined
  )

  const countryCode = computed((): RegionCode | (string & {}) | undefined => {
    if (props.defaultRegionCode) {
      return props.defaultRegionCode
    }
    return userCountryCode.value
  })

  watch(
    () => props.modelValue,
    (val) => {
      nextTick(() => {
        // if (!val && countryCode.value && setSelectedCountry) {
        //   setSelectedCountry(
        //     GatPhoneEditFunctions.getCountryAndDialCodeFromRegionCode(countryCode.value)
        //   )
        // }
      })
    },
    {
      once: true,
      immediate: true
    }
  )

  watch(
    () => countryCode.value,
    (val) => {
      if (setSelectedCountry) {
        nextTick(() => {
          if (
            props.modelValue &&
            GatPhoneEditFunctions.valueIsDialCodeOnly(props.modelValue) &&
            val
          ) {
            setSelectedCountry(
              GatPhoneEditFunctions.getCountryAndDialCodeFromRegionCode(val)
            )
          } else if (GatPhoneEditFunctions.emptyNumber(props.modelValue)) {
            setSelectedCountry(
              GatPhoneEditFunctions.getCountryAndDialCodeFromRegionCode(val)
            )
          }
        })
      }
    }
  )

  return {
    countryCode
  }
}
